import React from "react";
import { isCoach } from "../utils/user-helpers";

function View(props, { locals }) {
  const { query } = locals;

  return (
    <div id="login-wrapper">
      <form method="POST" action="/upgrade-coach" data-noreset>
        <img
          className="logo"
          src="/img/msb-logo-white.svg"
          alt="My Stength Book"
        />
        <div className="intro">
          <b>Welcome to MyStrengthBook For Coaches</b>
          Start your 14-day Free Trial today
        </div>

        <div className="Pricing-Plans Pricing-Plans-Coach">
          <div className="plan">
            <div className="head">Coaching</div>
            <div className="body">
              <div className="price">
                <span>$</span>
                <span>3.99</span>
                <span>per athlete</span>
                <span>USD / MONTH</span>
              </div>
              <div className="annual-note">
                Paid by coach, athletes access for free
              </div>
              <ul className="benefits">
                <li>
                  <b>Athlete Management System:</b>Keep track of all your
                  athletes in one place
                </li>
                <li>
                  <b>Custom Program Builder:</b>Design any program faster than
                  using Excel
                </li>
                <li>
                  <b>Training Library:</b>Store any program and re-use with
                  future athletes
                </li>
                <li>
                  <b>Intelligent Training Data:</b> Track metrics to understand
                  athlete training
                </li>
                <li>
                  <b>Video Analysis:</b> Receive athlete training videos and
                  provide comments
                </li>
                <li>
                  <b>Coach-Athlete Communication:</b>Leave notes on athlete
                  workouts
                </li>
              </ul>
            </div>
            <div className="foot">
              <button type="submit" className="button-input">
                Start your 14-day free trial
              </button>
            </div>
          </div>
        </div>

        <div className="login-signup">
          Don't plan on upgrading? <a href="/feedback">Tell us why.</a>
        </div>
      </form>
    </div>
  );
}

const UpgradeCoach = async (app) => {
  app
    .get("/upgrade-coach", ({ res, locals }) => {
      const { activeUser } = locals;
      if (!activeUser) {
        return res.redirect("/login");
      }
      if (isCoach(activeUser)) {
        return res.redirect("/coaching-portal");
      }
      res.body = <View />;
    })
    .post(
      "/upgrade-coach",
      async ({ res, req: { body }, api, locals, login, load, session }) => {
        const { activeUser } = locals;
        body.existingEmail = activeUser.email;
        body.email = activeUser.email;
        const { userId, token, email } = await (
          await api("register-coach", {
            method: "POST",
            body,
          })
        ).json();

        // ensures cache is busted and force reload from server
        session.items.forEach(({ key }) => {
          if (/(notification)|(user)|(cycle)/i.test(key)) session.delete(key);
        });

        const aU = await load("activeUser", {
          user: userId,
        });

        let sessionOptions = {
          refresh: true,
          ttl: "1 day",
        };
        const resp = await login(
          {
            _id: userId,
            token,
          },
          sessionOptions
        );

        // this cookie will determine if the coach should be redirected to the CP
        res.cookie("justLoggedIn", "1", {
          path: "/",
        });
        res.refreshWith(
          {},
          {
            url: `back`,
          }
        );
      }
    );
};

export default UpgradeCoach;
